import { Panel } from '../ui/Panel';
import { Field } from '../ui/Field';
import { inputCls } from '../ui/styles';
import { SettingNumber } from './SettingNumber';
import { SubscriptionSettings } from './SubscriptionSettings';
import { useSettings } from './useSettings';
import { euro } from '../../core/format/currency';

/** Instellingen › Webshop & verzending: verzending, ruilen en het Bewust Abonnement (ook een levering). */
export function ShippingSettings() {
  const {
    policy,
    setPolicy
  } = useSettings();
  return <>
      <Panel title="Verzending" description="Staan in de aankondigingsbalk, de winkelmand, de FAQ en de voorwaarden." data-id="element-4337" data-mp="anw8mqpjd6uo">
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4338" data-mp="5w4rt7w6mfhq">
          <SettingNumber label="Gratis verzending vanaf (€)" hint="Is meteen de eerste trede van de cadeaus bij bestelling." value={policy.freeShippingFrom} onChange={v => setPolicy('freeShippingFrom', v)} decimals data-id="element-4339" data-mp="yct9v117v4k" />
          <SettingNumber label="Verzendkosten (€)" hint="Daaronder." value={policy.shippingCost} onChange={v => setPolicy('shippingCost', v)} decimals data-id="element-4340" data-mp="tl7beladmiev" />
          <Field label="Vandaag besteld, morgen in huis tot" hint="Tijdstip waarop je de dag afsluit." data-id="element-4341" data-mp="2zctea48jiecs">
            <input type="time" value={policy.orderCutoff} onChange={e => e.target.value && setPolicy('orderCutoff', e.target.value)} className={`${inputCls} sm:max-w-[11rem]`} data-id="element-4342" data-mp="2kop45onjzb5m" />
          </Field>
        </div>
        <p className="mt-6 border-t border-line pt-4 text-[13px] text-muted" data-id="element-4343" data-mp="2fqdrl65vimjp">
          Op de site: “Gratis verzending vanaf {euro(policy.freeShippingFrom)}” · “{policy.returnDays} dagen ruilen als het niet bij je huid past” · “Voor {policy.orderCutoff} besteld, morgen in huis”
        </p>
      </Panel>

      <Panel title="Ruilen en nazorg" data-id="element-4344" data-mp="149r6zkvzx">
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4345" data-mp="3w2ap0xmdqqlc">
          <SettingNumber label="Ruiltermijn (dagen)" hint="Ook geopend, als het niet bij de huid past." value={policy.returnDays} onChange={v => setPolicy('returnDays', v)} max={365} data-id="element-4346" data-mp="4x18rxo6tqox" />
          <SettingNumber label="Even vragen hoe het gaat na (weken)" hint="Na een bestelling, voor je eigen opvolging." value={policy.followUpWeeks} onChange={v => setPolicy('followUpWeeks', v)} min={1} max={52} data-id="element-4347" data-mp="3upkq533ow3vj" />
          <SettingNumber label="“Bijna op” vanaf (dagen vooraf)" hint="Dan krijgt de klant een seintje om na te bestellen." value={policy.refillWarnDays} onChange={v => setPolicy('refillWarnDays', v)} max={90} data-id="element-4348" data-mp="m996r8s6xfxl" />
        </div>
      </Panel>

      <SubscriptionSettings data-id="element-4349" data-mp="14xwddvq0mdda" />
    </>;
}